import scssVars from '!!style-loader!css-loader!sass-loader!@/sass/_base.scss';
import { reflow } from 'bootstrap-vue/src/utils/dom';
import parseTransitionTime from '@/utils/transition-time';

const SELECTOR = 'vjs-collapse';

const EVENT_NAMES = {
    SHOW: 'vjs::collapse::show',
    SHOWN: 'vjs::collapse::show',
    HIDE: 'vjs::collapse::hide',
    HIDDEN: 'vjs::collapse::hidden'
};

let EVENTS = {};

Object.entries(EVENT_NAMES).forEach(([ name, type ]) => {
    EVENTS[name] = document.createEvent('CustomEvent');
    EVENTS[name].initEvent(type, true, true);
});

class Collapse {
    constructor(el) {
        this.toggleEl = el;
        this.toggleInstances = [];
        this.targetEl = null;
        this.expanded = false;
        this.transitionTime = parseTransitionTime(scssVars['collapse-transitionTime']) || 300;
        this.toggleShownClass = '-active';
        this.hiddenClass = scssVars['collapse-hiddenClass'] || 'collapse';
        this.transitioningClass = scssVars['collapse-transitioningClass'] || 'collapsing';
        this.shownClass = scssVars['collapse-shownClass'] || 'show';

        this.init();
    }

    init() {
        this.toggleInstances = document.querySelectorAll(`[${SELECTOR}][data-target="${this.toggleEl.dataset.target}"]`);
        this.targetEl = document.querySelector(this.toggleEl.dataset.target) || null;

        if(this.targetEl) {
            if(window.getComputedStyle(this.targetEl).display !== 'none' && window.getComputedStyle(this.targetEl).visibility !== 'hidden') {
                this.expanded = true;
                this.toggleAria();
            }
            this.setupListeners();
        }
    }

    destroy() {
        this.destroyListeners();
    }

    setupListeners() {
        this.toggleEl.addEventListener('click', this.bindedToggle);
        this.toggleEl.addEventListener(EVENT_NAMES.SHOW, this.bindedOnShow);
        this.toggleEl.addEventListener(EVENT_NAMES.HIDE, this.bindedOnHide);
    }

    destroyListeners() {
        this.toggleEl.removeEventListener('click', this.bindedToggle);
        this.toggleEl.removeEventListener(EVENT_NAMES.SHOW, this.bindedOnShow);
        this.toggleEl.removeEventListener(EVENT_NAMES.HIDE, this.bindedOnHide);
    }

    open() {
        this.dispatchEvt(EVENTS.SHOW);
        this.toggleEl.classList.add(this.toggleShownClass);
        this.toggleEl.classList.add(this.toggleShownClass);
        this.targetEl.classList.add(this.transitioningClass);
        setTimeout(() => {
            this.targetEl.style.height = `${this.targetEl.scrollHeight}px`;
        }, 0);

        setTimeout(() => {
            this.targetEl.removeAttribute('style');
            this.targetEl.classList.remove(this.transitioningClass);
            this.targetEl.classList.remove(this.hiddenClass);
            this.targetEl.classList.add(this.shownClass);
        }, this.transitionTime);
    }

    close() {
        this.dispatchEvt(EVENTS.HIDE);
        this.toggleEl.classList.remove(this.toggleShownClass);
        this.targetEl.style.height = `${this.targetEl.clientHeight}px`;
        this.targetEl.classList.add(this.transitioningClass);
        this.targetEl.classList.remove(this.shownClass);
        reflow(this.targetEl);
        this.targetEl.style.height = '0px';

        setTimeout(() => {
            this.targetEl.removeAttribute('style');
            this.targetEl.classList.remove(this.transitioningClass);
            this.targetEl.classList.add(this.hiddenClass);
        }, this.transitionTime);
    }

    toggleAria() {
        this.toggleEl.setAttribute('aria-expanded', this.expanded);
    }

    toggle() {
        this.expanded = !this.expanded;
        this.toggleAria();

        if(this.expanded) {
            this.open();
        } else {
            this.close();
        }
    }

    dispatchEvt(event) {
        this.toggleInstances.forEach(toggle => {
            if(this.toggleEl !== toggle) {
                toggle.dispatchEvent(event);
            }
        });
    }

    onShow() {
        this.expanded = true;
        this.toggleEl.classList.add(this.toggleShownClass);
        this.toggleAria();
    }

    onHide() {
        this.expanded = false;
        this.toggleEl.classList.remove(this.toggleShownClass);
        this.toggleAria();
    }

    // bind scope for removable event listeners
    bindedToggle = this.toggle.bind(this);
    bindedOnShow = this.onShow.bind(this);
    bindedOnHide = this.onHide.bind(this);
}

let instanceArr = [];

export function destroy() {
    instanceArr.forEach(instance => instance?.destroy());
    instanceArr.splice(0, instanceArr.length);
}

export default function() {
    const elements = document.querySelectorAll(`[${SELECTOR}]`);
    elements?.forEach((element, i) => {
        instanceArr[i] = new Collapse(element);
    });
}
